<div class="list-group-item requiredAction" *hideKey="'Profile-WebsiteAccess'">
    <div class="d-flex flex-wrap mb-2">
      <div class="mb-1 text-danger custom-required-actions-item-title" style="min-width: 100%">
        <i class="fa fa-exclamation-circle fa-2x text-danger float-start pe-2"></i>{{ 'ra_website_access' | translate }}
      </div>
      <div class="text-muted ms-4 mb-2" style='min-width: 38%'>
        <small>
          <span class="customer-required-actions-text font-italic">
            {{ 'ra_website_access_desc' | translate }}
          </span>
        </small>
      </div>
      <div class="ms-auto" style="min-width: 38%">
        <button routerLink="/user/website-access" class="btn btn-primary btn-sm align-self-start custom-required-actions-item-button w-100">
          {{ 'website_access' | translate }}
        </button>
      </div>
    </div>
  </div>
